<template>
  <div class="box">
    <!-- <div class="main">
      <h3>恭喜您,注册成功</h3>
      <p>
        您可以马上登陆
        <router-link to="/login">习讯云校企合作平台</router-link>发起合作申请啦！
      </p>
      <p>
        <el-button type="primary" @click="login()">马上登录</el-button>
      </p>
    </div> -->
    <div class="success">
      <div class="content">
        <div class="tip">提交成功！</div>
        <div class="info">
          <div class="t1">习讯-企校云平台</div>
          <div class="t2" style="color: #4090E6;">电脑登录网址：qxiaoyun.com</div>
          <div class="t2">校企合作/技能人才招聘一站式服务平台</div>
          <div class="t3">全国1000+学校&nbsp;&nbsp;&nbsp;&nbsp;100万+学生</div>
          <div class="t4">大数据精准匹配，开启您的校企合作之路</div>
        </div>
        <div class="back">
          <el-button type="primary" @click="backJob">立即体验</el-button>
        </div>
      </div>
      <div class="wx">
        <div>
          <span>习讯公众号</span>
          <img src="../../assets/img/qrcode/xixun.jpg" alt />
        </div>
        <div>
          <span>企校云小程序</span>
          <img src="../../assets/img/qrcode/qxy.jpg" alt />
        </div>
      </div>
    </div>
    <!-- <div class="member">
      <h3>校企合作企业会员认证</h3>
      <div class="introduce">
        <div class="title">请选择付费项目</div>
        <div class="fee-type">
          <div :class="feeType === 1 ? 'active' : ''" @click="feeType = 1">{{yearFee}}元/月</div>
        </div>
      </div>
      <div class="pay">
        <div class="choose">请选择支付方式</div>
        <div class="type">
          <div class="alipay" :class="active_index === 1 ? 'active' : ''" @click="active_index = 1">
            <img src="../../assets/img/alipay.png" />
          </div>
          <div :class="active_index === 2 ? 'active' : ''" @click="active_index = 2">境内银行汇款</div>
          <div :class="active_index === 3 ? 'active' : ''" @click="active_index = 3">境外银行汇款</div>
        </div>
        <div class="rights">
          <div class="title">企业认证后的权益：</div>
          <div>
            <span></span>招聘岗位在线发布给全校学生，学生随时随地在线应聘
          </div>
          <div>
            <span></span>学校校企合作、校园招聘、毕业生推荐等优先合作推荐
          </div>
          <div>
            <span></span>每年第一时间获取学校招聘通知，免去频繁出差跑学校的麻烦
          </div>
          <div>
            <span></span>应往届毕业生人才全网推荐匹配，节省企业招聘成本
          </div>
          <div>
            <span></span>优先共享推荐校企合作平台全网数百所学校及其学生资源
          </div>
          <div>
            <span></span>平台为您构建企业人力资源储备库，丰富毕业生人才简历资源
          </div>
        </div>
        <div class="agreement" style="margin-top: 20px;">
          <input type="checkbox" id="agree" />我已阅读并同意
          <a target="_blank" href="/#/agreement-pc">《习讯云校企合作平台信息服务协议》</a>
        </div>
        <div v-if="active_index === 1" class="mt20">
          <el-button v-if="needFee" type="primary" @click="alipay">立即认证</el-button>
          <el-button v-else type="primary" @click="openCooperation">开通校企合作</el-button>
        </div>
        <div class="detail" v-if="active_index === 2">
          <div class="con">
            <div>公司名称</div>
            <div>万博云信（北京）教育科技有限公司</div>
          </div>
          <div class="con">
            <div>开户行</div>
            <div>招商银行北京市分行营业部</div>
          </div>
          <div class="con">
            <div>银行账号</div>
            <div>110916866210201</div>
          </div>
          <div class="con">
            <div>交易附言</div>
            <div>请备注如下内容：会员认证 + 单位名称</div>
          </div>
        </div>
        <div v-if="active_index === 3"></div>
      </div>
    </div>-->
  </div>
</template>

<script>
import baseUrl from "@/api/baseUrl.js";
import axios from "axios";
import qs from "qs";

export default {
  data() {
    return {
      relationId: localStorage.getItem("relationId"),
      active_index: 1, // 支付方式：1、支付宝，2、境内银行汇款，3、境外银行汇款
      feeType: 1, // 费用类型：1、年费，2、季费
      yearFee: "", // 年费
      monthFee: "", // 季费
      payType: "" // 付费类型（plat：平台费，school：学校费）
    };
  },
  mounted() {
    this.getYearFee();
    // this.getMonthFee();
  },
  computed: {
    needFee() {
      if (this.feeType === 1 && this.yearFee !== "0") {
        return true;
      }
      if (this.feeType === 2 && this.monthFee !== "0") {
        return true;
      }
      return false;
    }
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    backJob() {
      this.$router.push("/");
    },
    async getYearFee() {
      let schoolId = localStorage.getItem("cooperationSchoolId");
      let res = await this.$api.pay.getYearFee(schoolId);
      this.yearFee = res.data.fee;
      this.payType = res.data.type;
    },
    async getMonthFee() {
      let res = await this.$api.pay.getMonthFee();
      this.monthFee = res.data;
    },
    // 开通校企合作
    async openCooperation() {
      // 是否同意服务协议
      let checked = document.getElementById("agree").checked;
      if (!checked) {
        this.$message.error("请先阅读并同意《习讯云校企合作平台信息服务协议》");
        return;
      }
      let res = await this.$api.pay.openCooperation(this.relationId);
      if (res.code === 0) {
        this.$router.push("/applyList");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 支付宝支付
    async alipay() {
      // 是否同意服务协议
      let checked = document.getElementById("agree").checked;
      if (!checked) {
        this.$message.error("请先阅读并同意《习讯云校企合作平台信息服务协议》");
        return;
      }

      // this.feeType === 1 ? this.payYearFee() : this.payMonthFee()
      if (this.payType === "plat") {
        this.payYearFee();
      } else if (this.payType === "school") {
        this.paySchoolFee();
      } else {
        this.$message.error("无付费类型！");
      }
    },
    payYearFee() {
      let params = {
        subject: "万博云信校企合作服务费",
        type: "web",
        school_id: localStorage.getItem("cooperationSchoolId")
      };
      axios
        .post(
          baseUrl + "api/enterprise/pay/platform/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    },
    payMonthFee() {
      let params = {
        subject: "万博云信校企合作服务费（季度）",
        type: "web"
      };
      axios
        .post(
          baseUrl + "api/enterprise/pay/platform/alipay/quarter",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    },
    async paySchoolFee() {
      let res = await this.$api.info.get();
      let params = {
        subject: "校企合作认证年费",
        type: "web",
        relation_id: this.relationId
      };

      axios
        .post(
          baseUrl + "api/enterprise/pay/school/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/base.scss";

.box {
  margin: 0 auto;
  width: 100%;
  .main {
    text-align: center;
    padding-top: 30px;
    h3 {
      font-weight: bold;
      font-size: 20px;
      color: #333;
    }
    p {
      margin-top: 30px;
    }
  }
  .success {
    padding-bottom: 200px;
    .t {
      display: flex;
      align-items: center;
      padding: 20px 0 0 100px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      span {
        font-size: 30px;
      }
    }
    .content {
      width: 500px;
      margin: 50px auto 0;
      border: 1px solid #ccc;
      border-radius: 10px;
      padding: 50px;
      .tip {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
      .info {
        text-align: center;
        .t1 {
          font-size: 25px;
          font-weight: bold;
          margin-top: 30px;
        }
        .t2 {
          margin-top: 10px;
          font-size: 20px;
        }
        .t3 {
          margin-top: 40px;
          color: $blue;
          font-size: 25px;
          font-weight: bold;
        }
        .t4 {
          margin-top: 10px;
          color: $blue;
          font-size: 20px;
        }
      }
      .back {
        text-align: center;
        margin-top: 20px;
      }
    }
    .wx {
      width: 400px;
      margin: 100px auto 0;
      display: flex;
      justify-content: space-between;
      & > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: bold;
        span {
          margin-bottom: 10px;
        }
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
  }
  .member {
    width: 700px;
    margin: 20px auto 0;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px 50px;
    h3 {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      color: #333;
    }
    .introduce {
      margin: 20px 0 0;
      padding: 20px 0 20px 20px;
      border-top: 2px solid #999;
      border-bottom: 2px solid #999;
      .fee-type {
        display: flex;
        margin: 20px 0 0;
        div {
          padding: 10px 20px;
          margin: 0 20px 0 0;
          border: 1px solid #999;
          border-radius: 5px;
        }
        div.active {
          color: $blue;
          border-color: $blue;
        }
      }
    }
    .pay {
      padding: 20px 0 0 20px;
      .type {
        margin: 20px 0 0;
        display: flex;
        div {
          padding: 10px 20px;
          margin: 0 5px 0 0;
          border: 1px solid #999;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .alipay {
          img {
            width: 80px;
          }
        }
        .active {
          border-color: $blue;
          color: $blue;
        }
      }
      .rights {
        margin: 20px 0 0;
        line-height: 1.5;
        .title {
          margin: 0 0 15px 0;
          font-weight: bold;
        }
        div span {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #4b7ff7;
          margin-right: 10px;
        }
      }
      .detail {
        display: flex;
        flex-direction: column;
        border: 1px solid #999;
        border-radius: 5px;
        margin: 20px 0 0;
        padding: 10px;
        .con {
          display: flex;
          margin: 0 0 10px;
          color: #a65b32;
          div:nth-child(1) {
            width: 100px;
            text-align: right;
            margin-right: 10px;
            font-weight: bold;
          }
        }
      }
    }
    .btn {
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;
      background: $blue;
      color: #fff;
      margin: 30px auto 0;
    }
  }
}
</style>